export function useHero() {
  const { $io } = useNuxtApp()
  const route = useRoute()

  const defaultTransition = {
    mode: 'out-in',
  }
  const mediaDefault = {
    media: {
      type: 'image',
      media: {
        src: '',
        alt: '',
      }
    }
  }
  const contentDefault = {
    content: {
      component: '',
      title: 'Hero',
      hairline: 'Hero',
      hairlineColour: 'white',
      titleColour: 'white',
      descriptionColour: 'white',
      description: 'Hero',
      line: false,
      lineColor: 'white',
    }
  }

  const overlayDefault = {
    transition: {
      mode: 'out-in'
    },
    overlays: []
  }
  const overlayGradientDefault = {
    type: 'gradient' as const,
    styles: {
      kind: 'linear' as const,
      direction: 'to bottom' as const,
      stops: [
        { color: 'rgba(0,0,0,0)', at: '0%' },
        { color: 'rgba(0,0,0,0.8)', at: '100%' },
      ],
      blendMode: 'normal',
      opacity: 1, // multiplier (0..1). You can omit this and just use RGBA in stops.
    },
    breakpoints: [] as NonNullable<IOHeroContentOverlays['overlays'][number]['breakpoints']>
  }


  // const overlayGradiantDefault = {
  //   type: 'gradient',
  //   styles: {
  //     direction: 'to bottom',
  //     colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
  //   },
  // }


  function heroBase(key: string, base: any) {
    $io.hero.base = { ...$io.hero.base, ...base }
    $io.hero.key = key
  }
  function heroMedia(key: string, media: any) {
    $io.hero.media = { ...mediaDefault, ...media }
    $io.hero.key = key
  }

  function heroContent(key: string, content: any) {
    $io.hero.content = { ...contentDefault, ...content }
    $io.hero.key = key
  }

  function heroOverlays(key: string, overlays: IOHeroContentOverlays) {
    const normalised = {
      transition: overlays.transition ?? { mode: 'out-in' },
      overlays: (overlays.overlays ?? []).map(o => {
        if (o.type !== 'gradient') return o
        return {
          ...overlayGradientDefault,
          // merge styles deeply but prefer caller values
          styles: { ...overlayGradientDefault.styles, ...o.styles },
          breakpoints: o.breakpoints ?? []
        }
      })
    }
    $io.hero.overlays = normalised
    $io.hero.key = key
  }

  function hero(heroSettings: IOHeroSettings, key?: string) {
    if (!key) {
      key = String(route.name)
    } 

    // Triggers the transitions 
    $io.hero.key = key
    if(heroSettings.base) {
      heroBase(key, { ...defaultTransition, ...heroSettings.base })
    }
    if(heroSettings.media) {
      heroMedia(key, { ...defaultTransition, ...heroSettings.media })
    }
    if(heroSettings.content) {
      heroContent(key, { ...defaultTransition, ...heroSettings.content })
    }
    if(heroSettings.overlays) {
      heroOverlays(key, { ...defaultTransition, ...heroSettings.overlays })
    }
    // if(heroSettings.overlays) {
    //   heroOverlays(key, heroSettings.overlays)
    // }
    // if(keys.includes('content')) {
    //   heroContent(key, heroSettings.content)
    // }
    // if(keys.includes('overlays')) {
    //   heroOverlays(key, heroSettings.overlays)
    // }
    // if(keys.includes('shapes')) {
    //   heroShapes(key, heroSettings.shapes)
    // }
    // if(keys.includes('divider')) {
    //   heroDivider(key, heroSettings.divider)
    // }
    

    // if (heroSettings) {
    //   Object.keys(heroSettings).forEach(settingKey => {
    //     if (typeof heroSettings[settingKey] === 'object' && heroSettings[settingKey] !== null) {
    //       ($io.hero as any)[settingKey] = { ...($io.hero as any)[settingKey], ...heroSettings[settingKey] }
    //     } else {
    //       ($io.hero as any)[settingKey] = heroSettings[settingKey]
    //     }
    //   })
    //   // the key is actually what can trigger the transitions
    //   $io.hero.key = key
    // }
  }

  return {
    hero,
    heroContent,
    heroMedia
  }
}